import React from 'react';
import moment from 'moment';
import { roundPrice } from 'lib/pricing_utils';
import { t } from 'services/translation';
import './index.scss';

class CheckoutSummaryPricingRemainder extends React.Component {
  static displayName = 'CheckoutSummaryPricingRemainder';

  _shouldRenderRemainderInLocal = () => {
    return (
      this.props.remainder_formatted !==
      this.props.remainder_in_local_currency_formatted
    );
  };

  _renderCreditNotes = () => {
    let dayCount = `${this.props.remainder_charge_days_offset}`;

    let dayText = t(
      `day${this.props.remainder_charge_days_offset > 1 ? 's' : ''}`
    );
    const month = t(moment(this.props.remainder_payment_date).format('MMMM'));
    const date = `${month} ${moment(this.props.remainder_payment_date).format(
      'Do, YYYY'
    )}`;

    const policyAttrs = {
      price: roundPrice(this.props.remainder_formatted),
      dayCount,
      dayText,
      date,
    };

    const policyLink = t(
      'THE_REMAINING_BALANCE_WILL_BE_CHARGED',
      '',
      policyAttrs
    );
    return (
      <div className="CheckoutSummary-CreditNotes">
        <p
          dangerouslySetInnerHTML={{
            __html: policyLink,
          }}
        />
      </div>
    );
  };

  _remainderInLocalCurrencyText = () => {
    return (
      <span>
        {' '}
        {t('PLEASE_PAY_IN_THE_LOCAL_CURRENCY_THE_AMOUNT_OF')}{' '}
        <strong>
          {roundPrice(this.props.remainder_in_local_currency_formatted)}
        </strong>
        .
      </span>
    );
  };

  _renderCashNotes = () => {
    const date = moment(this.props.date).format('MMMM Do, YYYY');
    return (
      <div className="CheckoutSummary-CashNotes">
        <p>
          {t('THE_REMAINING_BALANCE_OF')}{' '}
          <strong>{roundPrice(this.props.remainder_formatted)}</strong>{' '}
          {t('SHOULD_BE_PAID_WHEN_YOU_ARRIVE_ON', { date })}.
          {this._shouldRenderRemainderInLocal()
            ? this._remainderInLocalCurrencyText()
            : null}
        </p>
      </div>
    );
  };

  render() {
    return (
      <div className="CheckoutSummary-ContentBox RemainderNotes">
        {this.props.remainder_in_cash
          ? this._renderCashNotes()
          : this._renderCreditNotes()}
      </div>
    );
  }
}

export default CheckoutSummaryPricingRemainder;
